import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getBrandsLeasingList = (brandsLeasingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BRANDS_LEASING_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands-leasing/list`,
        brandsLeasingData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_BRANDS_LEASING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_BRANDS_LEASING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_BRANDS_LEASING_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addBrandsLeasing = (brandsLeasingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "ADD_BRANDS_LEASING_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands-leasing/add`,
        brandsLeasingData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_BRANDS_LEASING_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_BRANDS_LEASING_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_BRANDS_LEASING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateBrandsLeasing = (id, brandsLeasingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "UPDATE_BRANDS_LEASING_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands-leasing/update`,
        { ...brandsLeasingData, brand_leasing_id: id },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_BRANDS_LEASING_SUCCESS", payload: data });
        toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_BRANDS_LEASING_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_BRANDS_LEASING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewBrandsLeasing = (brandsLeasingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "VIEW_BRANDS_LEASING_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands-leasing/view`,
        brandsLeasingData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_BRANDS_LEASING_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_BRANDS_LEASING_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_BRANDS_LEASING_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const statusUpdateBrandsLeasing = (brandsLeasingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "STATUS_UPDATE_BRANDS_LEASING_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands-leasing/status-update`,
        brandsLeasingData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "STATUS_UPDATE_BRANDS_LEASING_SUCCESS",
          payload: data,
        });
        toast.success("Status Updated Successfully!!");
        return data;
      } else {
        dispatch({
          type: "STATUS_UPDATE_BRANDS_LEASING_FAILED",
          payload: data,
        });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "STATUS_UPDATE_BRANDS_LEASING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};